import { render, staticRenderFns } from "./AdministratorUpdate.vue?vue&type=template&id=70437a8c"
import script from "./AdministratorUpdate.vue?vue&type=script&lang=ts"
export * from "./AdministratorUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports